import { PathType } from '@convergence/types';
import { X } from '@phosphor-icons/react';
import { Button, Modal } from '@convergence/components';
import { useState } from 'react';
import { getError, valueFromTreeAndPath } from '../util';
import { AnalysisInputProps } from '../types';
import { LabFileBrowser } from '../../lab-file-browser';
import { LabFile } from '../../LabFile';
import { useStateLocalStorage } from '../../../hooks/useStateLocalStorage';

export function AnalysisPathInput(props: AnalysisInputProps<PathType>) {
  const [showFileBrowser, setShowFileBrowser] = useState(false);
  const value = valueFromTreeAndPath(props.tree, props.propertyPath) as {
    isFolder: boolean;
    bucketId?: number;
    path: string;
  }[];

  const error = getError(props.errors, props.propertyPath);

  const [fileBrowserState, setFileBrowserState] = useStateLocalStorage(
    'fileBrowser',
    {
      path: [] as string[],
      bucketId: null as number | null
    }
  );

  return (
    <div className="py-2 ">
      <div className="flex items-center gap-2 ">
        <label className="">{props.name}</label>
        <Button
          onClick={() => {
            setShowFileBrowser(!showFileBrowser);
          }}
        >
          {props.value._pathType === 'dir'
            ? 'Select Folder(s)'
            : 'Select File(s)'}
        </Button>
        {error && <p className="text-red-600">{error.message}</p>}
      </div>
      <div className="flex flex-col gap-1 pl-4">
        {value &&
          value.length > 0 &&
          value.map((v, i) => (
            <SelectedPath
              path={v.path}
              bucketId={v.bucketId ?? 0}
              isFolder={v.isFolder}
              key={`selected-path-${v.path}`}
              onDelete={() => {
                const newValue = [...(value ?? [])];
                newValue.splice(i, 1);
                props.onChange(props.propertyPath, newValue);
              }}
            />
          ))}
      </div>
      <Modal
        visible={showFileBrowser}
        onClose={() => setShowFileBrowser(false)}
        className=""
      >
        <div className="p-4 h-full overflow-hidden flex flex-col">
          <LabFileBrowser
            path={fileBrowserState.path}
            setPath={(path) =>
              setFileBrowserState({ ...fileBrowserState, path })
            }
            bucketId={fileBrowserState.bucketId ?? undefined}
            setBucketId={(bucketId) =>
              setFileBrowserState({ ...fileBrowserState, bucketId })
            }
            selection={value ?? []}
            pathType={props.value._pathType ?? 'file'}
            onSelectionChange={(selection) => {
              if (props.value._regexp) {
                const r = new RegExp(props.value._regexp);
                const filteredSelection = selection.filter((p) =>
                  r.test(p.path)
                );
                props.onChange(props.propertyPath, filteredSelection);
              } else {
                props.onChange(props.propertyPath, selection);
              }
            }}
          />
          <Button className="mt-4" onClick={() => setShowFileBrowser(false)}>
            Select
          </Button>
        </div>
      </Modal>
    </div>
  );
}

function SelectedPath(props: {
  bucketId: number;
  path: string;
  isFolder: boolean;
  onDelete: () => void;
}) {
  return (
    <div className="group flex items-center">
      <LabFile
        bucketId={props.bucketId}
        path={props.path}
        isFolder={props.isFolder}
      />
      <button
        onClick={props.onDelete}
        className="group-hover:block hidden cursor-pointer"
      >
        <X size={24} />
      </button>
    </div>
  );
}
